import NiceModal, { useModal } from "@ebay/nice-modal-react"
import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useToastDispatchContext } from '/src/layouts/toast/context/toastContext';
//import formData from "/src/utils/formData";
import Modal from "/src/components/modal/Modal";
import useModalHelper from "/src/components/modal/hooks/useModalHelper";
import Form from "/src/components/form/Form";
import Field from '/src/components/UI/Field/Field';
import "./DashboardFormBlockModal.css"
import dashboardService from '../../../services/dashboardService';
import { blockForm } from "../../../dashboardFormType"
import Dropdown from "/src/components/UI/DropDown/DropDown"
import Slider, { Slide, ScrollIntoSlide } from '/src/components/slider/sliderView';
import useVariablesBotAvailable from "../../../hooks/useVariablesBotAvailable"
import DashboardFormBlockSlideVariable from "./DashboardFormBlockSlideVariable";
import DashboardFormBlockMainSlide from "./DashboardFormBlockMainSlide";
import ButtonsSubmitFormBlockModal from "./ButtonsSubmitFormBlockModal"
import {addDashboardBlock,updateDashboardBlock} from "./DashboardBlockSubmitFormUtils"

const DashboardFormBlockModal = NiceModal.create(({ block, setBlock, dashboardChannel, bot }) => {
    var dashboard_id = dashboardChannel.dashboard.id;
    var type = block ? "update" : "create";
    var grid = type == "update" && block.type == 1 ? block.grid : null;
    const formData = blockForm[type];

    const { variablesBot } = useVariablesBotAvailable(dashboardChannel.id, bot.id, grid != null ? [block.variables[0].bot_variable_id] : [], { value: -1, text: "Nothing" });
    const modal = useModal();
    const { onClose } = useModalHelper(modal);
    const toast = useToastDispatchContext();

    const [stateFormGrid, setStateFormGrid] = useState(0);
    const { addBlock, editBlock } = dashboardService;


    const { register, handleSubmit, getValues, setValue, watch, clearErrors, formState: { errors }, formState, setError } = useForm({
        mode: "onChange",
        defaultValues: {
            "name": block ? block.name : "",
            "type": block ? block.type : 0,
        }
    })

    const onSubmit = async () => {
        /*
                let dataToSend = getValues();
        
                
                //delete dataToSend.empty;
                dataToSend.dashboard_id = dashboard_id;
                if (block != null) { // edit mode
                    dataToSend.block_id = block.id;
                    if (grid != null) {
                        dataToSend.grid_id = grid.id;
                    }
                }
                if (dataToSend.type == 0){
                    delete dataToSend.type_variable;
                }
                if (dataToSend.type == 1) {
                    if (dataToSend.type_variable == 0) {
                        dataToSend.default_value = dataToSend.default_value_checkbox == undefined ? (block != null && grid.type_variable == 0 ? grid.default_value : false) : dataToSend.default_value_checkbox;
                    }
                    if (dataToSend.type_variable == 2) {
                        dataToSend.default_value = dataToSend.default_value_dropdown;
                        dataToSend.placeholder_format = dataToSend.value_dropdown;
                    }
                    if (block == null) { // if block is empty, fill the array of cells
                        dataToSend.structure.cells = new Array(dataToSend.structure.rows.length * dataToSend.structure.columns.length).fill({ value: dataToSend.default_value, active: true })
                    }
                    /*
                    delete dataToSend.empty;
                    delete dataToSend.value_dropdown;
                    delete dataToSend.default_value_checkbox;
                    delete dataToSend.default_value_dropdown;
                        }
                    */
/*
        const [response, errors] = block != null ? await editBlock(dataToSend) : await addBlock(dataToSend)
        if (errors != null) {
            console.log(errors)
            return;
        }
        */
        let dataToSend = getValues();
        dataToSend.dashboard_id = dashboard_id;
        let res = null;
        dataToSend.name = dataToSend.name.trim();
        if (block == null ) { // If block ADD
            res= await addDashboardBlock(dataToSend)
        }
        else {
            res = await updateDashboardBlock(dataToSend, block)
        }
        
        modal.resolve(res.response);
        toast.success(res.titlePopup, res.bodyPopup)
        //toast.success('Block ' + (block ? " edited" : " added"), 'The block ' + response.name + " has been " + (block ? "edited !" : "added ! "));
        
        setBlock(res);

        onClose();

    };

    return (
        <Modal name={watch("type") == 1 ? "form_block_grid" : "form_block"} id={modal.id} onClose={onClose}>
            <div className="leave-container">
                <div className="button-leave" id="close_modal_container" onClick={() => onClose({ idIconModal: "close_modal_container" })} >
                    <i id="close_modal" className="fa fa-times" aria-hidden="true"></i>
                </div>
            </div>
            <Form className={"container_dashboard_form_block " + (watch('type') == 1 ? "dashboard_form_block_grid_mode" : "")} onSubmit={handleSubmit(onSubmit)}>
                <Form.Title>{formData.title}</Form.Title>

                <Form.Body className={(watch("type") == 1 ? "dashboard_form_block_grid_form_center" : "dashboard_simple_block_slide")}>
                    <Slider>
                        <Slide name="obligatory" className={"dashboard_form_block_slide"}>
                            <DashboardFormBlockMainSlide type={type} grid={grid} setValue={setValue} watch={watch} register={register} block={block} />
                        </Slide>

                        <Slide name="grid_slide_structure" className={(watch("type") == 1 ? "dashboard_form_block_slide dashboard_slide_grid" : "")}>
                            <DashboardFormBlockSlideVariable grid={grid} setValue={setValue} stateFormGrid={stateFormGrid} watch={watch} register={register} />
                        </Slide>

                        <Slide name="grid_slide_variables" className={"dashboard_form_block_slide grid_slide_variable_space"} >
                            <div>
                                {
                                    Array.isArray(variablesBot) &&
                                    <div className={"dropdown_grid_slide_container row_by_columnRow_container"}>
                                        <Field label={<span>Bot Variable<span style={{ color: "var(--pink)" }}> * </span></span>} listLabelClassName="field-modal" ></Field>
                                        <div className="special_container_dashboard_grid_form">
                                            <Dropdown {...register('bot_variable_id', { valueAsNumber: true })} setValue={setValue} choices={variablesBot} width="240px" defaultChoice={grid != null ? block.variables[0].bot_variable_id : -1}></Dropdown>
                                        </div>
                                    </div>
                                }

                            </div>
                        </Slide>
                    </Slider>
                </Form.Body>
                <Form.Buttons>
                    <ButtonsSubmitFormBlockModal onClose={onClose} typeForm={type} onSubmit={onSubmit} formState={formState} stateFormGrid={stateFormGrid} setStateFormGrid={setStateFormGrid} ScrollIntoSlide={ScrollIntoSlide} watch={watch} clearErrors={clearErrors} />
                </Form.Buttons>
            </Form>


        </Modal >
    )
});

export default DashboardFormBlockModal;